import { msg } from "@lingui/core/macro";
import { useNavigate } from "@tanstack/solid-router";
import { useI18n } from "@/providers/i18n-provider";
import { NotFoundState } from "@/components/ui/not-found-state";

/**
 * Router's global `defaultNotFoundComponent`: any unknown URL shows
 * this state instead of a blank screen. It renders inside the
 * root's `<Outlet>` (with all providers available).
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export function NotFoundRoute() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    // `data-testid` because the bundle boot gate needs to distinguish «the route
    // rendered» from «the router does not know it»: without this, a nonexistent URL paints this
    // screen, has visible text and the test accepts it.
    <div class="flex min-h-0 flex-1 items-center justify-center" data-testid="not-found-route">
      <NotFoundState
        variant="not-found"
        title={t(msg`Page not found`)}
        description={t(msg`The page you're looking for doesn't exist or has moved.`)}
        primaryAction={{
          label: t(msg`Go home`),
          onClick: () => {
            void navigate({ to: "/" });
          },
        }}
      />
    </div>
  );
}
